<template>
  <div class="text-info spinner-container">
    <div class="spinner-border" role="status"/>
    <span class="sr-only">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    text: {type: String, default: 'Loading...'},
  }
}
</script>

<style scoped>
.spinner-container {
  padding: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.spinner-border {
  margin-bottom: 1rem;
}
</style>
